import * as api from '../api'

//Action Creators
export const getCounties = () => async (dispatch) => {
  try {
    const { data } = await api.fetchCounties()
    dispatch({ type: 'FETCH_ALL_COUNTIES', payload: data })
  } catch (error) {
    dispatch({
      type: 'API_ERROR',
      payload: error.response.data.message,
    })
  }
}
